





























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-class';

@Component({
    name: 'SaveSearchDialog',
})
export default class SaveSearchDialog extends Vue {
    private resultsPerPage = 150;
    protected searchTitle = '';
    protected error = '';
    @Prop({
        required: true,
    })
    protected isSaveSearchDialogVisible!: boolean;
    @Action('search/addSavedSearch') protected addSavedSearch!: (
        name: string,
    ) => Promise<unknown>;

    @Watch('isSaveSearchDialogVisible')
    protected onSaveSearchToggle(value: boolean) {
        if (value) {
            this.$nextTick(() => {
                const inputTitle = this.$refs.inputTitle as HTMLElement;
                inputTitle.focus();
            });
        }
    }

    protected closeDialog() {
        this.$emit('closeDialog', 'save');
    }

    protected get isValid() {
        return this.searchTitle.length >= 1;
    }

    protected async onSaveSearch() {
        if (
            this.$store.getters['search/filteredSearchResults'].slice(
                0,
                this.resultsPerPage,
            ).length <= 0
        ) {
            this.$message.info('Please search for something first');
            return;
        }
        try {
            await this.addSavedSearch(this.searchTitle);
        } catch (e) {
            if (e.response.data.errors) {
                this.error = e.response.data.errors[0].detail;
            }
            return;
        }
        this.$message.success('Search saved!');
        this.$emit('closeDialog', 'save');
        this.searchTitle = '';
    }
}
